<li #drop ngbDropdown class="nav-item dropdown-notification ml-25">
  <a
    placement="bottom"
    ngbTooltip="{{ 'Dash.notif' | translate }}"
    class="nav-link"
    ngbDropdownToggle
    id="navbarNotificationDropdown"
    ><i class="ficon" data-feather="bell"></i
    ><span class="badge badge-pill badge-danger badge-up">{{ nbr }}</span></a
  >
  <ul
    ngbDropdownMenu
    aria-labelledby="navbarNotificationDropdown"
    class="dropdown-menu dropdown-menu-media dropdown-menu-right"
  >
    <!-- Notifications header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">{{ "Global.notif" | translate }}</h4>
        <div class="badge badge-pill badge-light-primary">
          {{ nbr }} {{ "Global.notif2" | translate }}
        </div>
      </div>
    </li>
    <!--/ Notifications header -->

    <!-- Notifications content -->
    <li class="scrollable-container media-list" [perfectScrollbar]>
      <a class="d-flex" href="javascript:void(0)" *ngFor="let message of notifications">
        <div class="media d-flex align-items-start">
          <div class="media-body">
            <p class="media-heading">{{ message.titre }}</p>
            <small class="notification-text">{{ message.message }}</small>
          </div>
        </div></a
      >
    </li>
    <!--/ Notifications content -->

    <!-- Notifications footer -->
    <li *ngIf="affButton" class="dropdown-menu-footer">
      <a class="btn btn-primary btn-block" (click)="navNotif()">{{
        "Global.notif3" | translate
      }}</a>
    </li>
    <!--/ Notifications footer -->
  </ul>
</li>
